import currency from './lib/currency';

export default {
  checkoutButton: 'Review and Checkout',
  emptyCart: 'Your cart is empty.',
  cartSubtotal: (valueSubtotal, priceSubtotal) => `Subtotal: ${currency(valueSubtotal)} for <strong>${currency(priceSubtotal)}</strong>`,
  lineItemPrice: (faceValue, price) => `${currency(faceValue)} for ${currency(price)}`,
  limitRemoveMessage: (excess) => `Unfortunately, you may not purchase more than $10,000 worth of gift cards per day. Please remove ${currency(excess)} from your cart to proceed.`, // eslint-disable-line
  limitReachedMessage: 'You have reached your $10,000 daily gift card limit. Please come back tomorrow to continue shopping.',
  learnMoreLink: 'Learn More',
  removeError: 'An error occurred removing the card from your cart. Please try again later.',
  loadError: 'An error occurred loading your cart. Please try again later.',
  addError: (brandName) => `This ${brandName} card just sold and is now unavailable.`,
  inCartButton: 'In Cart',
  unavailableButton: 'Unavailable',
};



/** WEBPACK FOOTER **
 ** ./apps/storePages/cartDropdown/copy.js
 **/